import { render, staticRenderFns } from "./chapterList.vue?vue&type=template&id=ecb0eed6&scoped=true"
import script from "./chapterList.vue?vue&type=script&lang=js"
export * from "./chapterList.vue?vue&type=script&lang=js"
import style0 from "./chapterList.vue?vue&type=style&index=0&id=ecb0eed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb0eed6",
  null
  
)

export default component.exports